
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { Autocomplete, Checkbox } from "@mui/material";
import { useMaterialUIController } from "context";

const NewCampaignEvent = () => {
    const navigate = useNavigate();
    const [controller] = useMaterialUIController()
    const [uid, setUID] = useState({ text: "", error: false, textError: "" });
    const [type, setType] = useState({ text: "", error: false, textError: "" });
    const [contactMade, setContactMade] = useState({ text: false, error: false, textError: "" });
    const [unknownContact, setUnknownContact] = useState({ text: false, error: false, textError: "" });
    const [eventNotes, setEventNotes] = useState({ text: "", error: false, textError: "" });
    const [spokeName, setSpokeName] = useState({ text: "", error: false, textError: "" });
    const [voiceMailTimeStamp, setVoiceMailTimeStamp] = useState({ text: "", error: false, textError: "" });
    const [company, setCompany] = useState();
    const [companyList, setCompanyList] = useState([]);
    const {darkMode} = controller;

    useEffect(() => {
        (async () => {
            const response = await CrudService.getAllCampaignCompany()
            setCompanyList(response.data)
        })()
    }, [])

    const submitHandler = async (e) => {
        e.preventDefault();

        const data = {
            uid: uid.text,
            event_type: type.text,
            contact_made: contactMade.text,
            unknown_contact: unknownContact.text,
            event_notes: eventNotes.text,
            spoke_name: spokeName.text,
            company_id: company?.company_id,
            voicemail_timestamp: voiceMailTimeStamp.text
        };
        try {
            await CrudService.createCampaignEvent(data);
            navigate("/campaign/event", {
                state: { value: true, text: "The event was successfully created" },
            });
        } catch (err) {
            if (err.hasOwnProperty("msg")) {
                setUID({ ...uid, error: true, textError: err.msg });
            }
            console.error(err);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Add New Campaign Event
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" method="POST" onSubmit={submitHandler}>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <FormField
                                        type="text"
                                        label="UID"
                                        name="uid"
                                        value={uid.text}
                                        error={uid.error}
                                        onChange={(e) => setUID({ ...uid, text: e.target.value })}
                                    />
                                    {uid.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {uid.textError}
                                        </MDTypography>
                                    )}
                                    <Autocomplete
                                        sx={{ marginTop: '0.5rem' }}
                                        defaultValue=""
                                        options={['phone', 'email']}
                                        // getOptionLabel={(option) => (option.attributes ? option?.attributes?.brand_name : "")}
                                        value={type.text ?? ""}
                                        onChange={(event, newBrand) => {
                                            setType({ ...type, text: newBrand });
                                        }}
                                        renderInput={(params) => (
                                            <FormField {...params} label="Event Type" InputLabelProps={{ shrink: type.text }} required />
                                        )}
                                    />
                                    <MDTypography fontSize={1}>
                                        <span style={{ fontWeight: "400", color: darkMode ? '#c3c5cc' : '#7b809a', fontSize: '0.875rem' }}>
                                            Contact Made: <Checkbox checked={contactMade.text} value={contactMade.text} onChange={() => setContactMade({ ...contactMade, text: !contactMade.text })} />
                                        </span>
                                    </MDTypography>
                                    <MDTypography fontSize={1}>
                                        <span style={{ fontWeight: "400", color: darkMode ? '#c3c5cc' : '#7b809a', fontSize: '0.875rem' }}>
                                            Unknown Contact: <Checkbox checked={unknownContact.text} onChange={() => setUnknownContact({ ...unknownContact, text: !unknownContact.text })} />
                                        </span>
                                    </MDTypography>
                                    <FormField
                                        type="text"
                                        label="Event Notes"
                                        name="event notes"
                                        value={eventNotes.text}
                                        error={eventNotes.error}
                                        onChange={(e) => setEventNotes({ ...eventNotes, text: e.target.value })}
                                    />
                                    {eventNotes.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {eventNotes.textError}
                                        </MDTypography>
                                    )}
                                    <FormField
                                        type="text"
                                        label="Spoke name"
                                        name="spoke name"
                                        value={spokeName.text}
                                        error={spokeName.error}
                                        onChange={(e) => setSpokeName({ ...spokeName, text: e.target.value })}
                                    />
                                    {spokeName.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {spokeName.textError}
                                        </MDTypography>
                                    )}
                                    <Autocomplete
                                        sx={{ marginTop: '0.5rem' }}
                                        defaultValue=""
                                        options={companyList}
                                        getOptionLabel={(option) => (option.company_name ?? "")}
                                        value={company ?? ""}
                                        onChange={(event, newCompany) => {
                                            setCompany(newCompany);
                                        }}
                                        renderInput={(params) => (
                                            <FormField {...params} label="Event Company" InputLabelProps={{ shrink: company }} required />
                                        )}
                                    />

                                    <FormField
                                        sx={{ width: '100%', marginTop: '30px' }}
                                        label={'VoiceMail Timestamp'}
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        // inputProps={{ min: today }}
                                        value={voiceMailTimeStamp.text}
                                        onChange={(event) => {
                                            setVoiceMailTimeStamp({
                                                ...voiceMailTimeStamp,
                                                text: event.target.value,
                                            })
                                        }}
                                    />

                                    {voiceMailTimeStamp.error && (
                                        <MDTypography sx={{ color: 'red', fontSize: '12px' }}>
                                            {voiceMailTimeStamp.textError}
                                        </MDTypography>
                                    )}

                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/campaign/event", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default NewCampaignEvent;
